module.exports = __webpack_public_path__ + "Roboto-Italic.ad4e08740474893c8f08.woff2";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/googleapi-fonts/Roboto-Italic.woff2
// module id = ../../../../../src/assets/vendors/base/fonts/googleapi-fonts/Roboto-Italic.woff2
// module chunks = styles